var Curriculog = Curriculog || {};

Curriculog.Paging = (function ($, _, Backbone, Paging) {
	
	Paging = Curriculog.CurriculogModel.extend({
		defaults: function() {
			return {
				totalProposals: 0,
				totalPages: 0,
				currentRange: [],
				pageRangePrevious: 0,
				pageRangeNext: 0,
			};
		},

		initialize: function(model, options) {
			this.params = options.params;
			this.collection = options.collection;
		},

		update: function() {
			this.setTotalProposals();
			this.setTotalPages();
			this.setRange();
		},

		setTotalProposals: function() {
			this.set('totalProposals', this.collection.length);
		},

		setTotalPages: function() {
			var totalProposals = this.get('totalProposals'),
				limit = this.params.pagingParams.get('limit');

			this.set('totalPages', parseInt(Math.ceil(parseFloat(totalProposals)/limit), 10));
		},

		setRange: function() {
			/*
			This function provides paging as a page range in groups of 10 pages at a time
			note: this is NOT related to limit

			note: roundedPage attempts to find ten range results in which the current page falls
			note: pageFloor is the top of the lower range, because we are zero based

			currentRange: (list of ints) list of 10 pages in the current viewer range
			pageRangePrevious: (int) the largest page number for the previous set of ten pages of results
			pageRangeNext: (int) the smallest page number for the next set of ten pages of results
			*/
			var pageFloor = 0,
				pageCeiling = 0,
				pageRange = [],
				currentPage = this.params.pagingParams.get('page'),
				roundedPage = Math.round(currentPage / 10) * 10,
				totalPages = this.get('totalPages'),
				range = _.range(1, totalPages + 1);

			if (currentPage > roundedPage) {
				pageFloor = roundedPage;
				pageCeiling = roundedPage + 10;
			} else {
				pageFloor = roundedPage - 10;
				pageCeiling = roundedPage;
			}
			pageRange = range.slice(pageFloor, pageCeiling);


			var pageRangeNext = 0,
				pageRangePrevious = 0;

			// if current page range does not include the final page AND
			// the next page is less than the final page, provide pageRangeNext int
			if ((_.indexOf(pageRange, totalPages) === -1) && ((pageCeiling + 1) < totalPages )) {
				pageRangeNext = pageCeiling + 1;
			}

			// if pageFloor is in the range (ie not 0) AND
			// 1 is not in the current page range, provide pageRangePrevious int
			if ((_.indexOf(range, pageFloor) !== -1) && (_.indexOf(pageRange, 1) === -1)) {
				pageRangePrevious = pageFloor;
			}

			// if we are viewing the end of the range, and it's bigger than 10 pages worth of results,
			// remove the last page from the range so the front end can cycle over the range list
			if ((totalPages > 10) && (_.indexOf(pageRange, totalPages) !== -1)) {
				pageRange.pop();
			}

			// if we are viewing the front of the range,
			// remove the first page from the range so the front end can cycle over the range list
			if (_.indexOf(pageRange, 1) !== -1) {
				pageRange.shift();
			}

			this.set('currentRange', pageRange);
			this.set('pageRangePrevious', pageRangePrevious);
			this.set('pageRangeNext', pageRangeNext);
		},

		reset: function() {
			this.set(this.defaults());
		},

	});

	return Paging;

})($, _, Backbone, Curriculog.Paging || {});